import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { ReservationService } from '../../core/services/application/flexseat/reservation.service';
import { GraphService } from '../../core/services/application/util/graph/graph.service';

type ThemeMode = 'tds-mode-light' | 'tds-mode-dark';

@Component({
  selector: 'app-header',
  imports: [TegelModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Output() toggleMenu = new EventEmitter<void>();
  @Output() modeToggle = new EventEmitter<void>();
  @Input() mode: ThemeMode = "tds-mode-light";

  private readonly reservationService = inject(ReservationService);
  private readonly graphService = inject(GraphService);

  userReservation = this.reservationService.userTodayReservation;

  title = this.verifyTitle();
  userName = this.graphService.userStorageData?.displayName || this.graphService.userGraphData()?.displayName || 'User not found';
  placeOfWork = this.graphService.userStorageData?.department || this.graphService.userGraphData()?.department || 'Department not found';
  pic = this.graphService.pic;

  /**
   * Toggles the sidebar visibility on mobile
   */
  toggleMobileSideMenu() {
    this.toggleMenu.emit();
  }

  /**
   * Makes the side menu visible and it's possible to change between light and dark mode
   */
  toggleMode() {
    this.modeToggle.emit();
    if (this.mode === "tds-mode-light") {
      this.mode = "tds-mode-dark";
    } else {
      this.mode = "tds-mode-light";
    }
  }

  private verifyTitle(): string {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname)
      ? window.location.hostname.toLowerCase()
      : '';

    if (host.includes('localhost') || (host.includes('.dev.') )) {
      return 'FLEXSEAT - DEVELOPMENT';
    }

    if (host.includes('.test.')) {
      return 'FLEXSEAT - HOMOLOGAÇÃO';
    }

    return 'FLEXSEAT';
  }


  
}
